import { render, staticRenderFns } from "./bottomFooter.vue?vue&type=template&id=48620536&scoped=true&"
import script from "./bottomFooter.vue?vue&type=script&lang=js&"
export * from "./bottomFooter.vue?vue&type=script&lang=js&"
import style0 from "./bottomFooter.vue?vue&type=style&index=0&id=48620536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48620536",
  null
  
)

export default component.exports